import React, { useEffect, useState, useContext, FormEvent } from "react";
import * as Styled from "./styles";
import GOFloatingbox from "../../common/GOFloatingbox";
import GOButton from "../../common/GOButton";
import { useTranslation } from "react-i18next";
import {
  NetReservationLoadCategory,
  NetReservationAdd,
  NetworkManager
} from "../../../actions";
import GODropbox from "../../common/GODropbox";
import GOInput from "../../common/GOInput";
import SmallTitle from "../../common/SmallTitle";
import GODate from "../../common/GODate";
import dayjs from "dayjs";
import isBetween from "dayjs/plugin/isBetween";
import { Context } from "../../../stores";
import { toast } from "react-toastify";
import {
  UFloatingContainer,
  UFloatingBoxHeader,
  UFloatingBoxFooter,
  UFloatingBoxBody
} from "../../../GlobalUtilityStyles";

dayjs.extend(isBetween);
interface AddProps {
  data?: any;
  id?: string;
  startDate?: string;
  onClickExit?: any;
  update?: any;
}

const daysChange = (value: number, t: any) => {
  switch (value) {
    case 0:
      return <span className="sun">{t("common.abrSunday")}</span>;
    case 1:
      return <span>{t("common.abrMonday")}</span>;
    case 2:
      return <span>{t("common.abrTuesday")}</span>;
    case 3:
      return <span>{t("common.abrWednesday")}</span>;
    case 4:
      return <span>{t("common.abrThursday")}</span>;
    case 5:
      return <span>{t("common.abrFriday")}</span>;
    case 6:
      return <span className="sat">{t("common.abrSaturday")}</span>;
    default:
      break;
  }
};

const Add = (props: AddProps) => {
  const { t } = useTranslation();
  const start = props.startDate + "T" + props.id + ":00";
  // const end = props.startDate + 'T' + '23:50';
  const [data, setData] = useState({
    ReservableCategoryIDs: [],
    plateNumbers: [],
    selectedDays: [dayjs(start).day()],
    name: [],
    startDate: new Date(start),
    endDate: new Date(
      dayjs(start)
        .add(60, "m")
        .format()
    ),
    startTime: new Date(start),
    endTime: new Date(
      dayjs(start)
        .add(60, "m")
        .format()
    ),
    endTimeOfDay: new Date(
      dayjs()
        .endOf("day")
        .format()
    ),
    memo: "",
    unit: 60
  });
  const [cat, setCat] = useState([]);
  const [plate, setPlate] = useState([]);
  const days = [0, 1, 2, 3, 4, 5, 6];

  useEffect(() => {
    NetReservationLoadCategory().then((res: any) => {
      setCat(res.data.Data.ProductCategories);
    });
  }, []);

  useEffect(() => {
    NetworkManager("get", `admin/plateAvailability/plate`).then((res: any) => {
      setPlate(res.data.Data.Plates);
    });
  }, []);

  const Store = useContext(Context);

  const handleChange = (e: any) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleCategoryChange = (e: any) => {
    if (e.target.value) {
      const v = e.target.value.split(",");
      if (
        data.ReservableCategoryIDs.filter((rcid: any) => rcid * 1 === v[0] * 1)
          .length === 0
      ) {
        setData({
          ...data,
          ReservableCategoryIDs: data.ReservableCategoryIDs.concat(v[0]),
          name: data.name.concat(v[1])
        });
      }
    }
  };

  const delCategory = (e: any, name: string) => {
    setData({
      ...data,
      ReservableCategoryIDs: data.ReservableCategoryIDs.filter(
        (rcid: any) => rcid * 1 !== e * 1
      ),
      name: data.name.filter((n: any) => n !== name)
    });
  };

  const handleSubmit = (e: FormEvent<EventTarget>) => {
    e.preventDefault();
    if (data.ReservableCategoryIDs.length < 1) {
      alert(t("reservation.selectOneOrMoreCategory"));
    } else if (data.plateNumbers.length < 1) {
      alert(t("reservation.selectOneOrMorePlate"));
    } else if (data.selectedDays.length < 1) {
      alert(t("reservation.selectRepeatDate"));
    } else if (dayjs(data.endDate).diff(data.startDate, "day") > 10) {
      alert(t("reservation.under10Days"));
    } else if (window.confirm(t("reservation.cancelExistingReservation"))) {
      Store.actions.setSending(true);
      NetReservationAdd({
        ...data,
        name: data.name.join(),
        startDate: dayjs(data.startDate).format("YYYY-MM-DDT00:00:00"),
        endDate: dayjs(data.endDate).format("YYYY-MM-DDT00:00:00"),
        startHour: dayjs(data.startTime).hour(),
        startMinute: dayjs(data.startTime).minute(),
        endHour: dayjs(data.endTime).hour(),
        endMinute: dayjs(data.endTime).minute()
      })
        .then(res => {
          alert(t("reservation.creationComplete"));
          Store.actions.setSending(false);
          props.update();
          props.onClickExit();
        })
        .catch((err: any) => {
          if (err.response) {
            toast.error(`${err.response.data.message}`);
            Store.actions.setSending(false);
          }
        });
    }
  };

  return (
    <GOFloatingbox width={1100}>
      <UFloatingContainer as="form" onSubmit={handleSubmit}>
        <UFloatingBoxHeader>
          <h1>{t("reservation.add")}</h1>
          <p>{t("reservation.addInfo")}</p>
        </UFloatingBoxHeader>
        <UFloatingBoxBody flex>
          <div className="flex_box">
            <SmallTitle body={t("reservation.info")} />
            <GODropbox
              label={t("reservation.ReservableCategory")}
              data={[
                ...cat.map((cat: any) => {
                  if (cat.type === 2) {
                    return { body: cat.name, value: [cat.id, cat.name] };
                  }
                  return {};
                })
              ]}
              onChange={handleCategoryChange}
              value={""}
            />
            <br />
            <SmallTitle
              body={
                t("reservation.ReservableCategory") + t("reservation.rCatInfo")
              }
            />
            {data.ReservableCategoryIDs.map((catd: any) => {
              const n: any = cat.filter((c: any) => c.id * 1 === catd * 1)[0];
              return (
                <GOButton
                  key={catd}
                  body={`${n.name} ×`}
                  onClick={() => delCategory(catd, n.name)}
                  buttontype="primary"
                  style={{ marginBottom: "10px" }}
                />
              );
            })}
          </div>
          <div className="flex_box">
            <SmallTitle body={t("reservation.selectPeriod")} />
            <GODate
              startDate={data.startDate}
              endDate={data.endDate}
              label={t("reservation.startDate")}
              selected={data.startDate}
              onChange={(date: any) => {
                setData({
                  ...data,
                  startDate: date,
                  endDate: date >= data.endDate ? date : data.endDate
                });
              }}
              required
            />
            <GODate
              startDate={data.startDate}
              endDate={data.endDate}
              minDate={data.startDate}
              label={t("reservation.endDate")}
              selected={data.endDate}
              onChange={(date: any) => {
                setData({ ...data, endDate: date });
              }}
              required
            />
            <br />
            <SmallTitle body={t("reservation.repeatedRange")} />
            <Styled.Plate>
              {days.map((p: any) => {
                if (
                  data.selectedDays.filter((rp: any) => {
                    return p * 1 === rp * 1;
                  }).length > 0
                ) {
                  return (
                    <div
                      key={p}
                      className="platebox platebox_choice"
                      onClick={() =>
                        setData({
                          ...data,
                          selectedDays: data.selectedDays.filter(
                            (rp: any) => rp * 1 !== p * 1
                          )
                        })
                      }
                    >
                      {daysChange(p, t)}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={p}
                      className="platebox"
                      onClick={() =>
                        setData({
                          ...data,
                          selectedDays: data.selectedDays.concat(p)
                        })
                      }
                    >
                      {daysChange(p, t)}
                    </div>
                  );
                }
              })}
            </Styled.Plate>
            <GODate
              label={t("common.startTime")}
              selected={data.startTime}
              time
              timeOnly
              dataFormat="aa h:mm"
              onChange={(date: any) => {
                setData({ ...data, startTime: date });
              }}
              required
            />
            <GODate
              label={t("common.endTime")}
              selected={data.endTime}
              time
              timeOnly
              minTime={data.startTime}
              maxTime={data.endTimeOfDay}
              dataFormat="aa h:mm"
              onChange={(date: any) => {
                setData({ ...data, endTime: date });
              }}
              required
            />
            <GOInput
              label={t("reservation.unit")}
              name="unit"
              onChange={handleChange}
              value={data.unit}
              unit={t("common.min")}
              required
            />
          </div>
          <div className="flex_box">
            <SmallTitle body={t("reservation.plateInfo")} />
            <Styled.PlateName>
              <div>{t("reservation.className")}</div>
              <input value={data.name.join()} readOnly />
            </Styled.PlateName>
            <GOInput
              label={t("reservation.memo")}
              name="memo"
              onChange={handleChange}
              value={data.memo}
              textarea
            />
            <br />
            <SmallTitle body={t("reservation.RelatedPlateNumbers")} />
            <Styled.Plate>
              {plate.map((p: any) => {
                if (
                  data.plateNumbers.filter((rp: any) => {
                    return p.number * 1 === rp * 1;
                  }).length > 0
                ) {
                  return (
                    <div
                      key={p.number}
                      className="platebox platebox_choice"
                      onClick={() =>
                        setData({
                          ...data,
                          plateNumbers: data.plateNumbers.filter(
                            (rp: any) => rp * 1 !== p.number * 1
                          )
                        })
                      }
                    >
                      {p.number}
                    </div>
                  );
                } else {
                  return (
                    <div
                      key={p.number}
                      className="platebox"
                      onClick={() =>
                        setData({
                          ...data,
                          plateNumbers: data.plateNumbers.concat(p.number)
                        })
                      }
                    >
                      {p.number}
                    </div>
                  );
                }
              })}
            </Styled.Plate>
            {plate.length === 0 && t("reservation.noPlateAvailable")}
          </div>
        </UFloatingBoxBody>
        <UFloatingBoxFooter>
          <GOButton
            buttontype="green"
            type="submit"
            body={t("common.add")}
            loading={Store.sending}
            disabled={Store.sending}
          />
          <GOButton
            body={t("common.no")}
            onClick={props.onClickExit}
            disabled={Store.sending}
          />
        </UFloatingBoxFooter>
      </UFloatingContainer>
    </GOFloatingbox>
  );
};
export default Add;
